import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import Navigation from './Navigation';
import logo from '../assets/logo.png';
import '../styles/Header.css';

function Header() {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo-container">
          {isHome ? (
            <img src={logo} alt="PrintMyTile Logo" className="logo" />
          ) : (
            <Link to="/">
              <img src={logo} alt="PrintMyTile Logo" className="logo" />
            </Link>
          )}
        </div>
        <Navigation />
      </div>
    </header>
  );
}

export default Header; 